import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosConfig";
import {
  ClearAllNotificationsApiArg,
  ClearAllNotificationsApiResponse,
  UserRes,
} from "./generated";
import { getRuntimeConfig } from "src/getRuntimeConfig";

export const baseApi = createApi({
  reducerPath: "api",
  refetchOnFocus: true,
  baseQuery: axiosBaseQuery({
    baseUrl: `${getRuntimeConfig().BASE_URL}${getRuntimeConfig().SUB_PATH}`,
  }),
  tagTypes: ["Notifications", "Watchlist", "UkOnboarding", "NotabeneTransfers"],
  endpoints: (builder) => ({
    clearAllNotifications: builder.mutation<
      ClearAllNotificationsApiResponse,
      ClearAllNotificationsApiArg
    >({
      query: () => ({
        url: `/user/notifications/clearAll`,
        method: "PUT",
      }),
      invalidatesTags: ["Notifications"],
    }),
    getUserDefaultCurrency: builder.query({
      query: () => ({
        url: `/dashboard/user`,
        method: "get",
      }),
      transformResponse: (res: UserRes) => res.defaultCurrencyConfig.code,
    }),
  }),
});
